import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { baseUrl } from './api-config';
import { Estensione } from '../models/estensione';
import { ResourcefulService } from './resourcefulService';
import { map, switchMap, takeUntil, takeWhile } from 'rxjs/operators';
import { interval, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class DeepPropertyService {
    constructor(private httpClient: HttpClient) {}

    processAddress(address: string, incaricoId: any): Promise<any> {
        return this.httpClient.post<any>(`${baseUrl}/deep-property/process`, { address, incaricoId }).toPromise();
    }

    checkStatus(jobId: string): Promise<any> {
        return this.httpClient.get<any>(`${baseUrl}/deep-property/check/${ jobId }`).toPromise();
    }

    getPDF(jobId: string, incaricoId: any): Promise<any> {
        return this.httpClient.get(`${baseUrl}/deep-property/pdf/${ jobId }/${ incaricoId }`).toPromise();
    }

    pollStatus(jobId: string, maxAttempts: number = 12, intervalMs: number = 5000): Observable<any> {
        return interval(intervalMs).pipe(
            switchMap(() => this.checkStatus(jobId)),
            takeWhile((response: any) => {
                if (response.status === 'RUNNING' || response.status === 'INITIALIZED' || response.status === 206)
                    return true;
                return false;
            }, true)
        );
    }
}